module.exports = __webpack_public_path__ + "static/img/szrl3.4320fef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/szrl3.png
// module id = T2HF
// module chunks = 73